/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import { get, isEmpty } from "lodash";
import useForm from "../../../hooks/useForm";
import {
  createWorkPlaces,
  updateWorkPlacesList,
} from "../../../apis/work-places";
import { cleanObj } from "../../../utils/cleanObj";
import Modal, { ModalHeader } from "../../../components/Modal";
import { autoSetMacAddress } from "../../../utils/replace";
import { viewLoading } from "../../../utils/loading";
import systemAlert from "../../../utils/systemAlert";
import { findModeLabel } from "../../../utils/mode";

import { isNumber } from "../../../utils/number";

import { toast } from "../../../utils/toast";
import { addressToCoord } from "../../../apis/maps";

const Location = ({
  list,
  mode = "create",
  open,
  setOpen,
  submit,
}) => {
  const [formFields, setFormFields] = useState([]);


  const getCoord = async (form, setForm) => {
    //console.log('form.addr1: ', form.addr1)
    if (form.addrCode && form.addr1) {
      const address = form.addr1;
      const addresses = await addressToCoord({ address });
      //console.log('addresses: ', addresses)

      if (addresses.length > 0) {
        form.latitude = addresses[0].y;
        form.longitude = addresses[0].x;
        setForm({ ...form });
      } else {
        toast.error("사업장 주소를 정확히 입력해주세요");
      }
    } else {
      toast.error("사업장 주소 입력 후 변환해주세요.");
    }
  };
  const validate = (data) => {
    const { placeName, addrCode, addr1, addr2, type, beaconId, beaconMacAddress, latitude, longitude, errorRange } = data;
    let errors = {};

    const regUUID = /^([a-fA-F0-9]{8})[-]([a-fA-F0-9]{4})[-]([a-fA-F0-9]{4})[-]([a-fA-F0-9]{4})[-]([a-fA-F0-9]{12})$/;
    const regMacAddr = /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/;

    // 사업장
    if (!placeName || (placeName.length > 100)) {
      errors.placeName = "사업장은 필수입니다.(100글자 이내)";
    }

    // 사업장 주소
    if (!addrCode || !addr1) {
      errors.address = "사업장 주소는 필수입니다.";
    }

    if (!addr2) {
      form.addr2 = " ";
    }

    // UUID
    if (type === 'beacon') {
      if (!beaconId) {
        errors.beaconId = "UUID를 입렵해주세요";
      } else if (!regUUID.test(beaconId)) {
        errors.beaconId = "UUID 형식을 확인해주세요.";
      }
      if (!beaconMacAddress) {
        errors.beaconMacAddress = "MAC Address 입력해주세요.";
      } else if (!regMacAddr.test(beaconMacAddress)) {
        errors.beaconMacAddress = "MAC Address 형식을 확인해주세요.";
      }
    } else if (type === 'gps') {
      if (!latitude || !isNumber(latitude)) {
        errors.latitude = "위도 입력해주세요( 예: 37.55696145945301 )";
      }
      if (!longitude || !isNumber(longitude)) {
        errors.longitude = "경도 입력해주세요( 예: 127.01757221069943 )";
      }
      if (!isNumber(errorRange)) {
        errors.errorRange = "허용반경거리를 입력해주세요( 예: 300 )";

      } else if (isNumber(+errorRange) && +errorRange > 800000) {
        errors.errorRange = "허용반경거리 최대값은 800,000 입니다.";
      }
    } else if (type === 'all') {
      if (!isEmpty(beaconId) || !isEmpty(beaconMacAddress)) {
        if (!beaconId) {
          errors.beaconId = "UUID를 입렵해주세요";
        } else if (!regUUID.test(beaconId)) {
          errors.beaconId = "UUID 형식을 확인해주세요.";
        }
        if (!beaconMacAddress) {
          errors.beaconMacAddress = "MAC Address 입력해주세요.";
        } else if (!regMacAddr.test(beaconMacAddress)) {
          errors.beaconMacAddress = "MAC Address 형식을 확인해주세요.";
        }
      }
      if (!latitude || !longitude) {
        if (!latitude || !isNumber(latitude)) {
          errors.latitude = "위도 입력해주세요( 예: 37.55696145945301 )";
        }
        if (!longitude || !isNumber(longitude)) {
          errors.longitude = "경도 입력해주세요( 예: 127.01757221069943 )";
        }
        if (!isNumber(errorRange)) {
          errors.errorRange = "허용반경거리를 입력해주세요( 예: 300 )";
        }
      }

      if (!beaconId && !latitude) {
        errors.type = "beacon/gps 둘중 하나이상의 정보를 입력하세요.";
      }
    }
    else {
      errors.type = "장치타입을 선택해주세요";
    }

    return errors;
  };

  const _submit = (form) => {
    const data = {
      ...form,
      errorRange: !isEmpty(form.errorRange) ? Number(form.errorRange) : "",
      latitude: !isEmpty(form.latitude) ? Number(form.latitude) : "",
      longitude: !isEmpty(form.longitude) ? Number(form.longitude) : "",
    };
    cleanObj(data);

    if (mode === "create") {
      systemAlert('출퇴근 장소를 등록하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              viewLoading(true);
              createWorkPlaces(data)
                .then(() => {
                  setOpen(false);
                  submit();
                  reset();
                })
                .catch((err) => {
                  console.error(err.response);
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    }
    if (mode === "modify") {
      const placeIdx = get(list, "idx");
      systemAlert('출퇴근 장소를 수정하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              viewLoading(true);
              updateWorkPlacesList(placeIdx, data)
                .then(() => {
                  setOpen(false);
                  submit();
                  reset();
                })
                .catch((err) => {
                  console.error(err.response);
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    setValues,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    reset,
  } = useForm(
    {
      placeName: "",
      addrCode: "",
      addr1: "",
      addr2: "",
      type: "gps",
      beaconId: "",
      beaconMacAddress: "",
      latitude: "",
      longitude: "",
      errorRange: "",
    },
    _submit,
    validate
  );

  useEffect(() => {
    setValues({
      placeName: get(list, "placeName") || "",
      addrCode: get(list, "addrCode") || "",
      addr1: get(list, "addr1") || "",
      addr2: get(list, "addr2") || "",
      type: get(list, "type") || "gps",
      beaconId: get(list, "beaconId") || "",
      beaconMacAddress: get(list, "beaconMacAddress") || "",
      latitude: get(list, "latitude") || "",
      longitude: get(list, "longitude") || "",
      errorRange: get(list, "errorRange") || "",
    });
  }, [list]);

  useEffect(() => {
    setFormFields([
      [
        {
          title: "사업장",
          key: "placeName",
          type: "input",
          required: true,
        },
      ],
      [
        {
          title: "사업장 주소", key: "address",
          onValue: (value, field, data) => {
            return `${data.addr1} ${data.addr2}`;
          },
          options: {
            addressDetailKey: 'addr2',
            addressKey: 'addr1',
            zipCodeKey: 'addrCode',
          },
          type: "address",
          className: 'full',
          required: true,
        },
      ],
      [
        {
          title: "장치타입",
          key: "type",
          type: "radio",
          options: {
            list: [
              { label: "Only Beacon", value: "beacon" },
              { label: "Only GPS", value: "gps" },
              { label: "Beacon/GPS (ALL)", value: "all" },
            ],
          },
          required: true,
        },
      ],
      [
        {
          title: "UUID",
          key: "beaconId",
          type: "input",
          options: {
            placeholder: "16진수(0~9,A~F) 8자리-4자리-4자리-4자리-12자리)",
            disabled: form.type === "gps",
          },
        },
      ],
      [
        {
          title: "MAC Address",
          key: "beaconMacAddress",
          type: "input",
          options: {
            disabled: form.type === "gps",
          },
          onKeyUp: (e) => {
            setValues({
              ...form,
              beaconMacAddress: autoSetMacAddress(e.target.value),
            });
          },
        },
      ],
      [
        {
          title: "위도",
          key: "latitude",
          type: "input",
          options: {
            placeholder: "위도 입력",
            disabled: form.type === "beacon",
          },
        },
        {
          title: "경도",
          key: "longitude",
          type: "input",
          options: {
            placeholder: "경도 입력",
            disabled: form.type === "beacon",
          },
        },
        {
          type: "button",
          color: "gray-line",
          label: "주소/좌표변환",
          action: () => { getCoord(form, setForm); },
        },
      ],
      [
        {
          title: "허용반경거리(m)",
          key: "errorRange",
          type: "number",
          options: {
            placeholder: "기본값(숫자입력) : 300",
            disabled: form.type === "beacon",
          },
        },
      ],
    ]);
  }, [form]);

  useEffect(() => {
    switch (form.type) {
      case "beacon":
        //setValues({ ...form, latitude: "", longitude: "", errorRange: "" });
        break;
      case "gps":
        //setValues({ ...form, beaconId: "", beaconMacAddress: "" });
        break;
      default:
        break;
    }
  }, [form.type]);

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="notice-write">
        <ModalHeader>
          출퇴근 장소 관리 {findModeLabel(mode)}
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={formFields}
          form={form}
          setForm={setForm}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default Location;
